const invertedMessages = {
  Success: 'CERTS_SUCCESS',
  Clear: 'CERTS_CLEAR',
  'The operation is taking longer than usual. Processing your request in the background.':
    'Certs.bulkAction.info',
  'Resync is in progress. Please retry after some time.': 'Certs.Resync.Info',
};

export default invertedMessages;
